import React, { Component } from 'react';
import * as jsPDF from 'jspdf';

import {
  Col,
  Container,
  Input,
  Row,
  Table,
  FormGroup,
  Label,
  Button
} from 'reactstrap';

class LabelPrinter extends Component {
  constructor (props) {
    super(props);
    this.state = {
      doc: new jsPDF(
        {
          orientation: 'landscape',
          unit: 'in',
          format: [110, 40]
        }

      )
    }

    this.print = this.print.bind(this);
  }

  print() {
    this.state.doc.setFontSize(4);
    this.state.doc.text('Hello world!', 1, 1);
    this.state.doc.save('a4.pdf');
  }

  render() {
    return (
      <div className="flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col xs="12" lg="8">
              <div className="card">
                <div className="card-body">
                  Helo world
                  <Button onClick={this.print}>Print</Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}


export default LabelPrinter;



// WEBPACK FOOTER //
// ./src/labelPrinter.js